import React, { useRef } from "react";
import { Box, Card } from "@curves/ui-base";
import useEChart from "@util/hook/useEChart";
import ChartSkeletonLoading from "@icoach/dashboard/ChartSkeletonLoading";

/********* 運動頻率分級 *********/
const WorkoutFrequencyLevel = React.forwardRef((props, ref) => {
	const chartDomRef = useRef(null);
	const {
		sourceData = {
			series: {
				data: [
					{
						itemStyle: { color: "#4C0073" },
						name: "A 會員-1個月",
						value: 18,
					},
					{
						itemStyle: { color: "#7E2E9C" },
						name: "B 會員~3個月",
						value: 22,
					},
					{
						itemStyle: { color: "#94A3B8" },
						name: "C 會員",
						value: 28,
					},
					{
						itemStyle: { color: "#CBD5E1" },
						name: "D 會員",
						value: 20,
					},
					{
						itemStyle: { color: "#E2E8F0" },
						name: "E 會員",
						value: 12,
					},
				],
				centerValueText: 40,
			},
		},
	} = props;
	const { series = {} } = sourceData;
	const seriesData = series?.data ?? [];
	const centerValueText = series?.centerValueText ?? "";
	const isLoading = seriesData.length === 0;

	const title = "運動頻率分級";
	const subTitle = "每月運動次數分組比例";

	const option = {
		backgroundColor: "#FFFFFF",
		title: {
			text: title,
			subtext: subTitle,
			left: 24,
			top: 20,
			textStyle: {
				fontSize: 20,
				fontWeight: 600,
				color: "#1F2937",
			},
			subtextStyle: {
				fontSize: 14,
				color: "#64748B",
				padding: [8, 0, 0, 0],
			},
		},
		tooltip: {
			trigger: "item",
		},
		// --- 圖例 ---
		legend: {
			bottom: 20,
			left: "center",
			itemWidth: 14,
			itemHeight: 14,
			icon: "roundRect",
			textStyle: {
				fontSize: 14,
				fontWeight: 600,
				color: "#111827",
			},
		},

		graphic: [
			{
				type: "text",
				left: "center",
				top: "47%",
				style: {
					text: "A+B 佔比",
					fill: "#94A3B8",
					fontSize: 26,
					textAlign: "center",
				},
			},
			{
				type: "text",
				right: "47%",
				top: "55%",
				style: {
					text: `${centerValueText}`,
					fill: "#4C0073",
					fontSize: 36,
					fontWeight: 700,
					textAlign: "center",
				},
			},
			{
				type: "text",
				left: "53%",
				top: "58%",
				style: {
					text: "%",
					fill: "#4C0073",
					fontSize: 20,
					fontWeight: 600,
					textAlign: "left",
				},
			},
		],

		series: [
			{
				type: "pie",
				radius: ["45%", "65%"],
				center: ["50%", "55%"],
				padAngle: 3,
				avoidLabelOverlap: false,
				label: { show: false },
				labelLine: { show: false },
				itemStyle: {
					borderRadius: 8,
				},
				data: seriesData,
			},
		],
	};

	useEChart(chartDomRef, option);

	return (
		<Card style={{ width: "100%", height: "100%" }}>
			<Card.CardContent style={{ width: "100%", height: "100%" }}>
				{isLoading ? <ChartSkeletonLoading /> : <Box ref={chartDomRef} style={{ width: "100%", height: "100%" }}></Box>}
			</Card.CardContent>
		</Card>
	);
});

export default WorkoutFrequencyLevel;
